<input
  class="form-control"
  appInput
  #phoneInput
  [(ngModel)]="value"
  [id]="id()"
  [placeholder]="placeholder() | translate"
  [required]="required()"
  [disabled]="ngControl?.control.disabled || readonly()"
  [readonly]="readonly()"
  (input)="onInput()"
  (focusout)="onFocusOut()"
/>
